import { ConsolidationGroupResponse } from "@common/schemas/domains/accounting/consolidation.schema";
import { ConsolidationTreatment } from "@common/types/domains/accounting/consolidation";
import { AccountingLedgerBasis } from "@common/types/domains/accounting/ledger";

export function getConsolidationBasisEntityUuids(
    group: ConsolidationGroupResponse,
): string[] {
    return [
        group.parentEntityUuid,
        ...group.members
            .filter(
                (member) =>
                    member.consolidationTreatment ===
                    ConsolidationTreatment.consolidates,
            )
            .map((member) => member.entityUuid),
    ];
}

export function getConsolidationGroupBasis(
    group: ConsolidationGroupResponse,
): AccountingLedgerBasis {
    return group.config?.basis ?? AccountingLedgerBasis.accruals;
}
